<template>
  <div class="ml-220 mt-80">
    <form @submit.prevent="addNewVideo">
      <div class="form-elems">
        <input
          name="video_name"
          :state="validateState('video_name')"
          v-validate="'required'"
          type="text"
          class="title-input"
          placeholder="Заголовок"
          v-model="title">
        <textarea
          name="video_text"
          :state="validateState('video_text')"
          v-validate="'required'"
          type="text"
          class="discription-input w-100 mt-2"
          placeholder="Описание"
          v-model="discription"
        ></textarea>
        <input
          name="video_link"
          :state="validateState('video_link')"
          v-validate="'required'"
          type="text"
          class="video-input"
          placeholder="Ссылка на видео"
          v-model="link">
        <button type="submit" class="type-submit">Добавить Видео</button>
      </div>
    </form>
    <div v-if="loading"  class="loader pt-100">
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
    <div class="video-list mt-5" v-else>
      <div class="d-flex flex-wrap" :class="[getVideo.length%2 === 0 ? 'justify-content-between' : 'justify-content-around']">
        <div
          class="w-33 mb-4"
          v-for="(item, id) in getVideo"
          :key="id">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" :src="item.link +'?rel=0'" allowfullscreen></iframe>
          </div>
          <input type="text" id="title" class="video-title-input" v-if="editId === item.id" :value="item.title">
          <h1 class="video-title" v-else>{{item.title}}</h1>
          <textarea type="text" id="discription" class="video-discription-input" v-if="editId === item.id" :value="item.discription"></textarea>
          <h2 class="video-discription" v-else>{{item.discription}}</h2>
          <div class="d-flex mt-2 justify-content-center">
            <b-button @click="deleteOldVideo(item.id)" variant="danger" class="mr-2 btn-width" size="sm">Удалить</b-button>
            <b-button size="sm" variant="primary" v-if="editId === item.id" @click="saveVideoChange(item)" class="btn-width">Сохранить</b-button>
            <b-button size="sm" variant="primary" v-else  @click="editVideo(item.id)" class="btn-width">Редактировать</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import validate from '@/mixins/validate';
  export default {
    name: "AdminVideoPage",
    mixins: [validate],
    data() {
      return {
        title: '',
        discription: '',
        link: '',
        loading: true,
        editId: null
      }
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchVideos(4)
      await this.setVideos(response)
      this.loading = false
    },
    computed: {
      ...mapGetters('video', ['getVideo'])
    },
    methods: {
      ...mapMutations('video', ['setVideos']),
      ...mapActions('video', ['addVideo', 'fetchVideos', 'deleteVideo', 'updateVideo']),
      async addNewVideo() {
        this.loading = true
        this.$validator.validate().then( async valid => {
          if (!valid) return
          const formData = {title: this.title, discription: this.discription, link: this.link}
          try {
            await this.addVideo(formData)
            this.resetData()
          } catch (e) {
            throw e
          }
        });

        this.loading = false
      },
      async deleteOldVideo(id) {
        this.loading = true
        await this.deleteVideo(id)
        this.loading = false
      },
      async saveVideoChange(item) {
        this.editId = null
        let title = document.getElementById('title').value
        let discription =  document.getElementById('discription').value
        await this.updateVideo({id: item.id, title, discription, link: item.link})
      },
      editVideo(id) {
        this.editId = id
      },
      resetData() {
        this.title = ''
        this.discription = ''
        this.link = ''
        this.$validator.reset();
      },
    }
  }
</script>

<style lang="scss">
  .w-33 {
    width: 28%;
  }
  .video-title-input {
    margin-top: 8px;
  }
  .discription-input {
    padding: 5px;
  }
  .video-discription-input {
    height: 200px;
  }
  .video-discription-input, .video-title-input {
    max-width: 500px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #dee2ed;
    padding: 5px;
    margin-bottom: 8px;
    display: block;
  }
  .video-list {
    font-family: 'Raleway', sans-serif;
    .editor {
      float: right;
      margin-top: 16px;
      span:first-child {
        margin-right: 20px;
      }
    }
  }
  .video-title {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    color: #1f1f1f;
    line-height: 1;
    margin-bottom: 12px;
  }
  .video-discription {
    font-size: 17px;
    margin: 0;
    line-height: 1.31;
    color: #1f1f1f;
  }
  input.video-input {
    width: 100% !important;
    height: 32px !important;
    font-size: 16px !important;
    padding: 5px !important;
    margin-top: 8px !important;
  }
  @media screen and (max-width: 1200px){
    .video-list {
      .w-33.mb-4 {
        width: 45%;
      }
    }
  }
  @media screen and (max-width: 992px){
    .video-list {
      .w-33.mb-4 {
        width: 100%;
      }
    }
  }
</style>